import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DATA_TYPE } from '../../config/data-type';
import { UPDATE_DATA_TYPE } from '../../../../../../store/js/modules/statspro/stats-leaders/actions';
import {
    roundSelector,
    statsLeadersBenchmarkingSelector,
    statsLeadersDataTypeSelector
} from '../../../../../../store/js/modules/statspro/stats-leaders/selectors';

export const useDataType = () => {
    const dispatch = useDispatch();
    const benchmarking = useSelector( statsLeadersBenchmarkingSelector );
    const dataType = useSelector( statsLeadersDataTypeSelector );
    const round = useSelector( roundSelector );

    const getValidType = newType => {
        // Only totals are available when viewing to individual rounds.
        if ( round ) {
            return benchmarking.isActive ?
                DATA_TYPE.BENCHMARKED_TOTALS :
                DATA_TYPE.TOTALS;
        }

        // Ensure the type is 'benchmarked{totals|averages}`
        if ( benchmarking.isActive ) {
            if ( [ DATA_TYPE.BENCHMARKED_AVERAGES, DATA_TYPE.BENCHMARKED_TOTALS ].includes( newType ) ) {
                return newType;
            }

            return newType === DATA_TYPE.TOTALS ?
                DATA_TYPE.BENCHMARKED_TOTALS :
                DATA_TYPE.BENCHMARKED_AVERAGES;
        }

        // Ensure the type is '{totals|averages}`
        if ( [ DATA_TYPE.AVERAGES, DATA_TYPE.TOTALS ].includes( newType ) ) {
            return newType;
        }

        return newType === DATA_TYPE.BENCHMARKED_TOTALS ?
            DATA_TYPE.TOTALS :
            DATA_TYPE.AVERAGES;
    };

    const updateDataType = newType => {
        const validType = getValidType( newType );
        if ( validType === dataType.type ) { return; }
        dispatch( UPDATE_DATA_TYPE.request( { type: validType } ) );
    };

    useEffect( () => {
        updateDataType( dataType.type );
    }, [ round, benchmarking.isActive ] );

    return { dataType, updateDataType };
};

